<template>
  <div class="my-3">
    <h3 class="mt-4">{{ $t("profile.alert-14-days") }}</h3>
    <hr />

    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form v-if="profile" @submit.stop.prevent="handleSubmit(onSubmit)">
        <b-row class="my-3">
          <b-col>
            <b-form-checkbox switch size="lg" v-model="profile.emailOn">
              {{ $t("profile.email") }}
            </b-form-checkbox>
          </b-col>
          <b-col>
            <validation-provider
              :rules="{ required: true, email: true }"
              v-slot="validationContext"
            >
              <b-input-group>
                <template v-slot:append v-if="profile.emailOn && profile.email">
                  <b-input-group-text>
                    <a href="#">
                      <b-icon icon="alarm" @click="doAlert('email')" />
                    </a>
                  </b-input-group-text>
                </template>
                <b-form-input
                  v-model="profile.email"
                  :disabled="!profile.emailOn"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
              </b-input-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col>
            <div>
              <b-form-checkbox
                switch
                size="lg"
                v-model="profile.barkOn"
                style="display: inline-block"
              >
                {{ $t("profile.bark") }}

                <a href="https://github.com/Finb/bark-server" target="_blank">
                  <b-icon icon="question-circle-fill" @click.stop></b-icon>
                </a>
              </b-form-checkbox>
            </div>
          </b-col>
          <b-col>
            <validation-provider
              :rules="{ required: false, url: true }"
              v-slot="validationContext"
            >
              <b-input-group>
                <template v-slot:append v-if="profile.barkOn && profile.bark">
                  <b-input-group-text>
                    <a href="#">
                      <b-icon icon="alarm" @click="doAlert('bark')" />
                    </a>
                  </b-input-group-text>
                </template>
                <b-form-input
                  v-model="profile.bark"
                  :state="getValidationState(validationContext)"
                  :disabled="!profile.barkOn"
                  placeholder="https://example.com/yourtoken/"
                ></b-form-input>
              </b-input-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col>
            <b-form-checkbox switch size="lg" v-model="profile.serverChanOn">
              {{ $t("profile.server-chan") }}
              <a href="http://sc.ftqq.com/3.version" target="_blank">
                <b-icon icon="question-circle-fill" @click.stop></b-icon>
              </a>
            </b-form-checkbox>
          </b-col>
          <b-col>
            <validation-provider
              :rules="{ required: false, max: 55 }"
              v-slot="validationContext"
            >
              <b-input-group>
                <template
                  v-slot:append
                  v-if="profile.serverChanOn && profile.serverChan"
                >
                  <b-input-group-text>
                    <a href="#">
                      <b-icon icon="alarm" @click="doAlert('serverChan')" />
                    </a>
                  </b-input-group-text>
                </template>
                <b-form-input
                  v-model="profile.serverChan"
                  :state="getValidationState(validationContext)"
                  :disabled="!profile.serverChanOn"
                  placeholder="SCKY"
                ></b-form-input>
              </b-input-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col></b-col>
          <b-col>
            <b-button @click.prevent="onSubmit">{{
              $t("profile.save")
            }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import EventBus from "@/plugins/eventbus";
export default {
  data() {
    return {
      profile: null
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const res = await this.$api.users.getUserProfile();
      this.profile = res.data?.data?.profile;
      this.$store.commit("user/setProfile", this.profile);
    },
    doAlert(type) {
      this.$bvModal
        .msgBoxConfirm(this.$t("profile.send-test-message", { type }), {
          okTitle: this.$t("base.ok"),
          cancelTitle: this.$t("base.cancel")
        })
        .then(res => {
          if (!res) {
            return;
          }
          this.$api.users.sendTestAlert({
            accountType: type,
            account: this.profile[type]
          });
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }

        if (this.profile.emailOn && this.profile.email === "") {
          this.profile.emailOn = false;
        }
        if (this.profile.barkOn && this.profile.bark === "") {
          this.profile.barkOn = false;
        }
        if (this.profile.serverChanOn && this.profile.serverChan === "") {
          this.profile.serverChanOn = false;
        }

        this.$api.users.saveUserProfile(this.profile).then(() => {
          EventBus.$emit("i18n-toast", {
            variant: "primary",
            message: "PROFILE-SUCCESS"
          });
          this.loadData();
        });
      });
    }
  }
};
</script>
